import { Head } from "@inertiajs/react";
import { ActionIcon, Flex, Group, Stack, Title } from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons-react";
import type { PropsWithChildren, ReactNode } from "react";

type ContentShellProps = PropsWithChildren<{
  pageTitle?: string;
  title: string;
  titleIcon?: ReactNode;
  actions?: ReactNode;
  onBack?: () => void;
  center?: boolean;
}>;

export function ContentShell({ title, pageTitle = title, onBack, actions, children, titleIcon, center = false }: ContentShellProps) {
  return (
    <>
      <Head>
        <title>{pageTitle}</title>
      </Head>
      <Stack align={center ? "center" : undefined}>
        <Flex justify="space-between">
          <Group>
            {onBack && (
              <ActionIcon variant="transparent" color="zli-blue" onClick={onBack}>
                <IconArrowLeft />
              </ActionIcon>
            )}
            <Group>
              <Title>{title}</Title>
              {titleIcon}
            </Group>
          </Group>
          <Group>{actions}</Group>
        </Flex>
        {children}
      </Stack>
    </>
  );
}
